import { associatedItemsRenderer } from '@lib/generic.utils'
import { metadataColDefs } from '@/utils/metadataColDefs'
import { notAnyPriceCheck, notAnyValueCheck } from '@/ag-grid/utils/notAnyValue'
import { agPriceCol } from '@/ag-grid/ag-columns'

const licensesCol = () => ({
  headerName: 'License',
  field: 'has_licenses',
  type: ['centerAligned'],
  cellRenderer: params => (params.value ? 'Yes' : 'No'),
  tooltipValueGetter: params => (params.value ? 'Yes' : 'No'),
  filter: 'CustomFilter',
  floatingFilterComponentFramework: 'DropdownFilter',
  filterParams: {
    filterType: 'boolean',
    type: 'contains',
    options: [
      { label: 'Yes', value: 'yes' },
      { label: 'No', value: 'no' }
    ]
  }
})

export default {
  computed: {
    metadataColDefs,

    columnDefs() {
      return [
        {
          headerName: 'Name',
          field: 'name',
          tooltipField: 'name',
          type: ['textFilterColumn'],
          cellRendererFramework: 'LinkRenderer',
          cellRendererParams: params => ({ route: `/${this.isVendor ? 'vendors' : 'publishers'}/${params.data.id}` })
        },

        {
          headerName: 'Abbreviation',
          field: 'abbreviation',
          type: ['textFilterColumn'],
          tooltipValueGetter: notAnyValueCheck,
          cellRenderer: notAnyValueCheck
        },

        {
          headerName: 'Account Number',
          field: 'customer_account_number',
          type: ['textFilterColumn'],
          tooltipValueGetter: notAnyValueCheck,
          cellRenderer: notAnyValueCheck
        },

        {
          headerName: 'License Manager',
          field: 'owner',
          type: ['textFilterColumn'],
          tooltipValueGetter: params => notAnyValueCheck({ ...params, value: params.value?.name }),
          cellRenderer: params => notAnyValueCheck({ ...params, value: params.value?.name })
        },

        ...(this.isVendor ? [] : [licensesCol()]),

        agPriceCol('Active Subscriptions', 'active_subscriptions', {
          cellRenderer: params => params.value ?? 'N/A',
          tooltipValueGetter: params => associatedItemsRenderer(params.value, 'subscription', 'subscriptions')
        }),

        agPriceCol('Total Value Original Currency (incl. One-time purchases)', 'subscription_value_original', {
          cellRenderer: params => notAnyPriceCheck(params, 'subscription_value_original_currency'),
          tooltipValueGetter: params => notAnyPriceCheck(params, 'subscription_value_original_currency', true),
          headerClass: ['multiple-lines', 'text-right'],
          maxWidth: 200
        }),

        agPriceCol('Total Value Local Currency (incl. One-time purchases)', 'subscription_value_local', {
          cellRenderer: params => notAnyPriceCheck(params, 'subscription_value_local_currency'),
          tooltipValueGetter: params => notAnyPriceCheck(params, 'subscription_value_local_currency', true),
          headerClass: ['multiple-lines', 'text-right'],
          maxWidth: 180
        })
      ]
    },

    gridOptions() {
      return {
        columnDefs: [...this.columnDefs, ...this.metadataColDefs],

        defaultColDef: {
          floatingFilter: true
        },

        suppressRowClickSelection: true,
        rowModelType: 'serverSide',
        serverSideStoreType: 'partial',
        cacheBlockSize: 40
      }
    }
  }
}
